/**
 * Gestione Sottoscrizioni
 *
 * Contact: bonjoprg@gmail.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { PassaggioContantiEntity } from './passaggioContantiEntity';
import { UserEntity } from './userEntity';


export interface SubscriptionReportDto { 
    id: number;
    nomeCompleto: string;
    email: string;
    telefono: string;
    importo: string;
    modalitaPagamento: SubscriptionReportDtoModalitaPagamentoEnum;
    intestatario?: string;
    iban?: string;
    rateizzazione?: string;
    firmaBase64: string;
    pdfUrl?: string;
    dataSottoscrizione: string;
    versata: boolean;
    dataVersamento?: string;
    inCaricoAId: string;
    creataDaId: string;
    createdAt: string;
    updatedAt: string;
    creataDa: UserEntity;
    inCaricoA: UserEntity;
    passaggiContanti: Array<PassaggioContantiEntity>;
}
export enum SubscriptionReportDtoModalitaPagamentoEnum {
    Contanti = 'CONTANTI',
    Bonifico = 'BONIFICO',
    Pos = 'POS',
    Rid = 'RID'
};



